const CalculatePreSchool = (data) => {
  const totalArea = data.reduce((a, b) => a + (b.square || 0), 0);
  const totalSeats = data.reduce((a, b) => a + (b.seats || 0), 0);
  const totalQueue = data.reduce((a, b) => a + (b.queue || 0), 0);

  const totalAvailableSeats = data.reduce(
    (a, b) => a + (b.availableSeats || 0),
    0,
  );
  const totalSurplus = data.reduce((a, b) => a + (b.surplus || 0), 0);
  const totalDeficit = data.reduce((a, b) => a + (b.deficit || 0), 0);
  const totalContingent = data.reduce((a, b) => a + (b.kontingent || 0), 0);
  // API /datastub/ddo отдаёт napravleniya / zachisleno; старые имена — запасной вариант.
  const totalIssuedDirections = data.reduce(
    (a, b) => a + (b.napravleniya || b.issuedDirections || 0),
    0,
  );
  const totalEnrolled = data.reduce(
    (a, b) => a + (b.zachisleno || b.enrolled || 0),
    0,
  );
  // Отклонение считает сервер (deviation); если его нет — мощность − наполненность.
  const totalDeviation = data.reduce(
    (a, b) =>
      a +
      (b.deviation != null
        ? b.deviation
        : (b.seats || 0) - (b.kontingent || 0)),
    0,
  );

  let pieStat = {
    surplus: 0,
    shortage: 0,
    normal: 0,
  };
  data.forEach((item, index) => {
    data[index].x = data[index].longitude;
    data[index].y = data[index].latitude;
    let percent = item.seats ? (item.kontingent / item.seats) * 100 : null;
    if (percent === null) {
      data[index].status = "Нет данных";
      data[index].color = "#828282";
    } else if (percent < 90) {
      // дальше как было
      pieStat.surplus++;
      data[index].status = "Профицит";
      data[index].color = "#01b8aa";
    } else if (percent > 100) {
      pieStat.shortage++;
      data[index].status = "Дефицит";
      data[index].color = "#fd625e";
    } else {
      pieStat.normal++;
      data[index].status = "Норма";
      data[index].color = "#fbc02d";
    }
    if (item.languageKz && item.languageRu) {
      data[index].studyLang = "смешанный";
    } else if (item.languageKz) {
      data[index].studyLang = "казахский";
    } else {
      data[index].studyLang = "русский";
    }
  });
  let barChart = data.map((el) => {
    return {
      category: el.name,
      value: el.seats,
      value1: el.kontingent,
    };
  });
  barChart = barChart.filter((el) => el.value && el.value1);
  const pieData = [
    {
      category: "Профицит",
      value: pieStat.surplus,
    },
    {
      category: "Норма",
      value: pieStat.normal,
    },
    {
      category: "Дефицит",
      value: pieStat.shortage,
    },
  ];
  const tableHead = [
    {
      key: "name",
      label: "Наименование",
    },
    {
      key: "address",
      label: "Адрес",
    },
    {
      key: "district",
      label: "Район",
    },
    {
      key: "studyLang",
      label: "Язык обучения",
    },
    {
      key: "form",
      label: "Форма учреждения",
    },
    {
      key: "seats",
      label: "Проектая мощность",
    },
    {
      key: "kontingent",
      label: "Фактическая наполненность",
    },
    {
      key: "status",
      label: "Заполненность",
    },
    {
      key: "type",
      label: "Вид ДДО",
    },
    {
      key: "time",
      label: "Продолжительность нахождения",
    },
  ];

  let pieLang = [
    {
      category: "смешанный",
      value: 0,
    },
    {
      category: "казахский",
      value: 0,
    },
    {
      category: "русский",
      value: 0,
    },
  ];
  data.forEach((item) => {
    pieLang.forEach((pie) => {
      if (
        item.studyLang ===
        pie.category.charAt(0).toLowerCase() + pie.category.slice(1)
      )
        pie.value++;
    });
  });
  let typePieChart = [
    ...new Set(data.filter((e) => e.type).map((e) => e.type)),
  ];
  typePieChart = typePieChart.map((e) => {
    return {
      category: e,
      value: 0,
    };
  });
  typePieChart.forEach((el) => {
    data.forEach((item) => {
      if (el.category === item.type) el.value++;
    });
  });

  let timePieChart = [...new Set(data.map((e) => e.time))];
  timePieChart = timePieChart.map((e) => {
    return {
      category: e,
      value: 0,
    };
  });
  timePieChart.forEach((el) => {
    data.forEach((item) => {
      if (el.category === item.time) el.value++;
    });
  });

  const queuePieChart = [
    { category: "В очереди", value: totalQueue },
    { category: "Зачислено", value: totalContingent },
  ];

  const localityMap = {};
  data.forEach((item) => {
    if (!item.locality) return;
    localityMap[item.locality] =
      (localityMap[item.locality] || 0) + (item.availableSeats || 0);
  });
  const freePlaces = Object.entries(localityMap)
    .map(([category, value]) => ({ category, value }))
    .sort((a, b) => b.value - a.value);

  const tableData = {
    objects: data,
    head: tableHead,
  };

  return {
    totalArea,
    totalSeats,
    totalContingent,
    totalQueue,
    totalAvailableSeats,
    totalSurplus,
    totalDeficit,
    data,
    pieData,
    pieLang,
    tableData,
    barChart,
    timePieChart,
    typePieChart,
    queuePieChart,
    freePlaces,
    totalIssuedDirections,
    totalEnrolled,
    totalDeviation,
  };
};
export default CalculatePreSchool;
